/* 
These functions make sure WordPress 
and Foundation play nice together.
*/
jQuery(document).ready(function() {
	widgetSlider();
	siteJsEssentials();
	initParallax();
	coolColorOverLay();
	initHpVideo();
	checkVideo();
	initScroller();
	//formLabel2Placeholder();
	mobileExpandr();
	cf7fix();
	initPreloaderScreen();
	initWidgetCheck();
	initNavigationJs();
	//initProcedureSliderChanger();
});
jQuery(window).resize(function() {
	navCheck();
	initWidgetCheck();
});
jQuery(window).scroll(function() {
	navCheck();
});
jQuery(window).on('changed.zf.mediaquery', function(event, newSize, oldSize) {
	// newSize is the name of the now-current breakpoint, oldSize is the previous breakpoint  
});

function mobileExpandr() {
	
	var expandTar = jQuery('.mobileExpand'),
		ehmax = '',
		expandTarBtn = '<a class="expandBtn"><span class="showMe">Expand</span><span class="hideMe">Collapse</span></a>';
	
	expandTar.wrapInner('<div class="expandrContent"></div>');
	expandTar.append(expandTarBtn);

	jQuery('.expandrContent').each( function(){
		ehmax = jQuery(this).parent().data('eh-max');
		jQuery(this).find('.expandrContent').css('max-height', ehmax);		
		jQuery(this).css('max-height', ehmax );
	});
	
	jQuery('.expandBtn').on('click', function(){
		jQuery(this).find('.rotateMe').toggleClass('none down');
		jQuery(this).find('span').toggleClass('showMe hideMe');
		jQuery(this).parent().find('.expandrContent').toggleClass('expanded');
		jQuery(this).toggleClass('expanded');	
	});
		
}

function initSpecialInterchangeMediaQueries() {
	
	Foundation.Interchange.SPECIAL_QUERIES['tablet2x'] = 'screen and (min-device-width: 1024px) and (max-device-width: 1366px) and (-webkit-min-device-pixel-ratio: 2)';
	Foundation.Interchange.SPECIAL_QUERIES['mobile2x'] = 'screen and (min-device-width: 1024px) and (max-device-width: 1366px) and (-webkit-min-device-pixel-ratio: 2)';
	Foundation.Interchange.SPECIAL_QUERIES['desktop2x'] = 'screen and (min-device-width: 1200px) and (max-device-width: 1600px) and (-webkit-min-device-pixel-ratio: 2) and (min-resolution: 192dpi)';
	
	
}


/*
function mailingList(){
	if(sessionStorage.getItem('mailPopUp') != 'shown') {
		jQuery('#news-letters').foundation('open');
	
		jQuery('#news-letters button.close-button').on( 'click', function(){		
			console.log('hello');
			sessionStorage.setItem('mailPopUp','shown');
			jQuery('#news-letters').foundation('close');
			
		});
    }
}
*/

function initWidgetCheck() {
	var widgetWidth = jQuery(".widget_acf_widget_5").width();
	
	
	if (widgetWidth < 771 ) {
			jQuery(".widget_acf_widget_5 .content-container").addClass('smaller').removeClass('larger');
	} else {
		jQuery(".widget_acf_widget_5 .content-container").addClass('larger').removeClass('smaller');
	}
}


function initNavigationJs(){	
	

	var parent_selector,
		new_height,
		new_height_2,
		current_height = 0,	
		previous_height = 0;
	
	jQuery('.menu-bar-wrapper .desktop-menu .menu-wrapper ul.menu li.menu-item-has-children>ul.submenu>li.menu-item-has-children').hover(
	function() {		
		
		
		new_height = jQuery(this).children('.level-1').outerHeight( true );
		parent_height = jQuery(this).parent('.level-0').outerHeight( true );		

	
		if(new_height != null) { 
			if( new_height >= parent_height) {
				jQuery(this).parent('.submenu.level-0').css('min-height', (new_height + 2 ) +'px' );
			} else {
				jQuery(this).children('.submenu.level-1').css('min-height', parent_height +'px' );
			}
			
		}

  	}, function() {	  
	jQuery(this).parent('.submenu.level-0').css('min-height', 'auto' );
	jQuery(this).children('.submenu.level-1').css('min-height', 'auto' );

  });

}

function initPreloaderScreen() {
	jQuery('.home .menu-bar-wrapper').css('display', 'none');
	setTimeout(function() {
		jQuery('.home #loader').addClass('animated zoomOut');
	}, 800);
	setTimeout(function() {
		jQuery('.home #loader-wrapper').fadeOut('slow');
		jQuery('.home .menu-bar-wrapper').css('display', 'block');
	}, 1200);
	var fpBannerLogo = jQuery('.slide-logo');
	var fpButton = jQuery('.fp-banner-link');
	var fpfixedlogo = jQuery('.box .button');
	if (fpBannerLogo) {
		fpBannerLogo.css('opacity', 0);
		setTimeout(function() {
			fpBannerLogo.css('opacity', 1);
			fpBannerLogo.addClass('animated zoomIn');
		}, 1400);
	}
	if (fpfixedlogo) {
		setTimeout(function() {
			fpfixedlogo.addClass('animated fadeIn');
			 logoFaderOne();
		}, 1400);
	}
	if (fpButton) {
		fpButton.css('opacity', 0);
		setTimeout(function() {
			fpButton.css('opacity', 1);
			fpButton.addClass('animated fadeIn');
		}, 1300);
	}
	initSubmenus();
}

function logoFaderOne(){
	jQuery('.img-container').css('opacity','1');
	setTimeout(function() { 
	jQuery('.img-container').css('opacity','0');		
	  logoFaderTwo();		
	}, 8000);
}

function logoFaderTwo(){

	jQuery('.linker').css('opacity','1');	
	setTimeout(function() { 
	jQuery('.linker').css('opacity','0');	
	jQuery('.img-container').css('opacity','0');	
	logoFaderOne();		
	}, 8000);
}

function initSubmenus() {
	jQuery('.top-bar #menu-topnav-1').css('opacity', 1);
	setTimeout(function() {
		jQuery('.top-bar .fixedlogo').css('display', 'block');
	}, 800);
}
// dont forget to put the CSS
// form.form label { display: none; }
//

function formLabel2Placeholder() {
	jQuery("form :input").each(function(index, elem) {
		var eId = jQuery(elem).attr("id");
		var label = null;
		if (eId && (label = jQuery(elem).parents("form").find("label[for=" + eId + "]")).length == 1) {
			jQuery(elem).attr("placeholder", jQuery(label).html());
			jQuery(label).remove();
		}
	});
}

function initProcedureSliderChanger(){
	jQuery(".proc-controller").click(function() {
	
		  var dataController = jQuery(this).attr("data-p-target");
		  var dataTarget = jQuery("#procedure-wrapper-"+dataController);
		  
		  if(dataTarget.hasClass( "active" )){

			  return false;
		  } else {	
			 		  			    
			  for (var ctr = 1; ctr <= 2; ctr++) {
			    if (dataController != ctr) {
				    jQuery('.cont-'+ctr+' .fa').addClass(" fa-circle-thin").removeClass("neon fa-circle");							    
			     	jQuery("#procedure-wrapper-"+ctr).addClass('sliderOut');			   
			      }	
			  }
			jQuery('.cont-'+dataController+' .fa').removeClass("fa-circle-thin").addClass("neon fa-circle");		
			setTimeout(function() {  	
				jQuery(".procedure-wrapper").removeClass("sliderOut active");
				jQuery(dataTarget).addClass("active");		
				Foundation.reInit('equalizer');		
			}, 3000);
			if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
					var target = jQuery(this.hash);
					target = target.length ? target : jQuery('[name=' + this.hash.slice(1) + ']');
					if (target.length) {
						setTimeout(function() {  
							jQuery('html,body').animate({
								scrollTop: target.offset().top - 150
							}, 1000);
						}, 3000);
						return false;
					}
				}		
		  	}
	});	
	
	jQuery(".mobile-proc-toggle").click(function() { 

		var dataController = jQuery(this).attr("data-p-target");
		var dataTarget = jQuery("#procedure-wrapper-"+dataController);
		
			for (var ctr = 1; ctr <= 2; ctr++) { 
				if (dataController != ctr) { 
					jQuery("#procedure-wrapper-"+ctr).removeClass("active");
					var $carousel = jQuery('#mobile-carousel-'+ctr).flickity();
					$carousel.flickity('destroy');
				} 
				dataTarget.addClass("active");
				jQuery(".mobile-proc-toggle").removeClass("active");
				jQuery(".mobile-proc-toggle li i").removeClass("fa-circle").addClass("fa-circle-thin");
				jQuery(".procMob-"+dataController).addClass("active").find("li i").removeClass("fa-circle-thin").addClass("fa-circle");

				
				jQuery('#mobile-carousel-'+dataController).flickity({
					cellAlign: 'center',
					contain: true,
					pageDots:false,
				});
			}
						
		 return false;
	});	
	
}

function cf7fix() {
	jQuery('input.wpcf7-submit').click(function() {
		setTimeout(function() {
			jQuery('input.wpcf7-submit').attr('disabled', 'disabled');
		}, 100);
	});
	jQuery(".wpcf7").on('wpcf7:submit', function(event) {
		jQuery(this).find('input.wpcf7-submit').removeAttr('disabled');
	});
}
// CHECKS FOR STATIC / FIXED NAVIGATION

function navCheck() {
	var isDesktop = jQuery(document).width() > 1000 ? true : false;
	// If document (your website) is wider than 1023px, notVisible = true, else notVisible = false
	if (!isDesktop) {
		
		desktopNavToggle();
	} else {
		desktopNavToggle();
	}
}
var toggler = false;
var previousScroll = 0;

function desktopNavToggle() {
	var offset = jQuery('#menu-bar-wrapper').offset();
	if (offset) {
		var height = jQuery(window).scrollTop();
		var currentScroll = jQuery(window).scrollTop();
		if (currentScroll < previousScroll && toggler === true && height < 95 && offset.top < 145) {
			jQuery('.home #menu-bar-wrapper').addClass('swipeup');
			toggler = false;
		}
		previousScroll = currentScroll;
		if (height < 89 && offset.top < 140) {
			toggler = false;
		} else {
			toggler = true;
			jQuery('.home #menu-bar-wrapper').addClass('fixed');
			jQuery('.home #menu-bar-wrapper').removeClass('swipeup');
		}
		if (currentScroll < 30) {
			jQuery('.home #menu-bar-wrapper').removeClass('swipeup');
			jQuery('.home #menu-bar-wrapper').removeClass('fixed');
		}
	}
}
// CUSTOM SLIDER WIDGET SCRIPT

function widgetSlider() {
	jQuery('.sbReviewsSlider').flickity({
		// options
		cellAlign: 'left',
		contain: true,
		autoPlay: 3500,
		wrapAround: true,
		pageDots: false,
		prevNextButtons: false,
		imagesLoaded: true,
		cellSelector: ".wSlide",
		arrowShape: {
			x0: 10,
			x1: 70,
			y1: 40,
			x2: 70,
			y2: 40,
			x3: 70
		}
	});
	
	jQuery('#mobile-carousel-1').flickity({
			cellAlign: 'center',
			contain: true,
			pageDots:false,
		});
	
	
		
	var serviceSliderBg = jQuery(".service-sub-carousel");
	
	if(serviceSliderBg.length) {
		serviceSliderBg.flickity({		  
		  cellAlign: 'center', 		  	 
		  contain: true,
		  autoPlay: 10000,
		  wrapAround: true,
		  pageDots: true,			  
		  prevNextButtons: false,
		  imagesLoaded: true,
		  adaptiveHeight: false,
		});			
	} 
}

function initParallax() {
	// use data-fptop to set the default starting point of the bg image
	// eg. <div data-fptop="100" style="background-image:url('somebg.jpg')></div>
      /* Uses the default class name 'banner-parallax' on the frontpage banner, use data-speed="0.2"(20% scroll rate use decimals)  */                
      
      	
    jQuery(window).on('load scroll', function () {
        var scrolled =  jQuery(this).scrollTop();
		var scrollBottom = jQuery(this).scrollTop() + jQuery(this).height();   		
        jQuery('.banner-parallax').each(function(){ 
	        	var speed = jQuery(this).attr('data-speed');
	        	var position = jQuery(this);
	        	var bottom = position.position().top + position.outerHeight(true);	  		        	
	        
	        	if(scrolled <= bottom) {	
	        		jQuery(this).css('transform', 'translate3d(0, ' + -(scrolled  * speed) + 'px, 0)');
	        	}        	     	
        });
    });
}

function siteJsEssentials() {
	// Remove empty P tags created by WP inside of Accordion and Orbit
	jQuery('.accordion p:empty, .orbit p:empty').remove();
	// Makes sure last grid item floats left
	jQuery('.archive-grid .columns').last().addClass('end');
	// Emma Form Tracking
	jQuery('#emma-form-submit').addClass('emmaTrackingLink');
	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').wrap("<div class='flex-video'/>");
	//console.log('hello dev team!');
}
// VIDEO FOR FRONT PAGE

function initHpVideo() {
	var isTouchDevice = /Windows Phone/.test(navigator.userAgent) || ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch;
	jQuery('.promo .video').each(function() {
		var holder = jQuery(this);
		var video = holder.find('video');
		var isDesktop = jQuery(document).width() < 1025 ? true : false;
		if (isTouchDevice && isDesktop) {
			video.remove();
			jQuery(".promo").addClass("mobile");
			jQuery(".promo").removeClass("desktop");
		} else {
			jQuery(".promo").addClass("desktop");
		}
	});
}

function checkVideo() {
	var vid = document.getElementById("fpVideo");
	if (vid) {
		vid.onloadedmetadata = function() {
			jQuery('.loader').fadeOut('slow');
		};
	}
}

function initScroller() {
	jQuery('.scrollink').click(function() {
		if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
			var target = jQuery(this.hash);
			target = target.length ? target : jQuery('[name=' + this.hash.slice(1) + ']');
			if (target.length) {
				jQuery('html,body').animate({
					scrollTop: target.offset().top - 40
				}, 1000);
				return false;
			}
		}
	});
}
//  coolColorOverlay Hover box 
//  this is dependent on /scss/sections/plugins/cool-color.scss (include it via style.scss)
/*
	- to add coolColorOverlay to and element in your templates add the class .coolColor 
	the js will look for a link with a class of .button to act as the trigger that will fade the background color when hovered.
	
	- if you would like to fade out any child elements with the color add a class of .unThis to them.  
	
	- Available data attributes for coolColorOverlay  
	
	data-cool-this="1" 
	this allows the color to fade away when we hover on the target button
	set value to 1 or true to enable and 0 or false to disable
	(by default this is disabled)
	
	data-image-src="url"
	(add this if you would like a background image)
	
	data-cool-color="primary"
	this chooses the overlay color. It pull directly from the foundation color pallet 
	the default / fallback is primary
	you may also set it to: secondary, success, warning, alert, black or white
	
	data-cool-btn="primary"
	this sets the hover color of the target button (if not set it will fallback to the data-cool-color value)
	you may also set it to: secondary, success, warning, alert, black or white
*/
function coolColorOverLay() {
	jQuery(".coolColor").each(function() {
		var ccattr = jQuery(this).attr('data-cool-color');
		var bcattr = jQuery(this).attr('data-cool-btn');
		if (typeof ccattr !== typeof undefined && ccattr !== false && ccattr !== '') {
			ccattr = jQuery(this).attr('data-cool-color');
		} else {
			ccattr = 'primary';
		}
		if (typeof bcattr !== typeof undefined && bcattr !== false && bcattr !== '') {
			bcattr = jQuery(this).attr('data-cool-btn');
		} else {
			bcattr = ccattr;
		}
		jQuery(this).children().wrapAll("<div class='coolContent'></div>");
		jQuery(this).children().find('.button').addClass(bcattr);
		var bgattr = jQuery(this).attr('data-image-src');
		if (typeof bgattr !== typeof undefined && bgattr !== false) {
			jQuery(this).addClass(ccattr).css({
				'background': 'url(' + bgattr + ')',
				'background-repeat': 'no-repeat',
				'background-size': 'cover',
				'background-position': 'center top',
				'padding': '3rem 0 5rem',
			});
		} else {
			jQuery(this).css({
				'position': 'relative',
				'padding': '3rem 0 5rem',
			});
		}
		var coolthis = jQuery(this).attr('data-cool-this');
		if (typeof coolthis !== typeof undefined && coolthis !== false && (coolthis === 'true' || coolthis === '1') && (coolthis !== '' || coolthis !== 0 || coolthis !== 'false')) {
			jQuery(this).find('.button').hover(function() {
				jQuery(this).parents('.coolColor').toggleClass('unCoolThis');
			});
		} else {}
	});
}
/*
CSS Browser Selector v0.4.0 (Nov 02, 2010)
Rafael Lima (http://rafael.adm.br)
http://rafael.adm.br/css_browser_selector
License: http://creativecommons.org/licenses/by/2.5/
Contributors: http://rafael.adm.br/css_browser_selector#contributors
*/
function css_browser_selector(u) {
	var ua = u.toLowerCase(),
		is = function(t) {
			return ua.indexOf(t) > -1;
		},
		g = 'gecko',
		w = 'webkit',
		s = 'safari',
		o = 'opera',
		m = 'mobile',
		h = document.documentElement,
		b = [(!(/opera|webtv/i.test(ua)) && /msie\s(\d)/.test(ua)) ? ('ie ie' + RegExp.$1) : is('firefox/2') ? g + ' ff2' : is('firefox/3.5') ? g + ' ff3 ff3_5' : is('firefox/3.6') ? g + ' ff3 ff3_6' : is('firefox/3') ? g + ' ff3' : is('gecko/') ? g : is('opera') ? o + (/version\/(\d+)/.test(ua) ? ' ' + o + RegExp.$1 : (/opera(\s|\/)(\d+)/.test(ua) ? ' ' + o + RegExp.$2 : '')) : is('konqueror') ? 'konqueror' : is('blackberry') ? m + ' blackberry' : is('android') ? m + ' android' : is('chrome') ? w + ' chrome' : is('iron') ? w + ' iron' : is('applewebkit/') ? w + ' ' + s + (/version\/(\d+)/.test(ua) ? ' ' + s + RegExp.$1 : '') : is('mozilla/') ? g : '', is('j2me') ? m + ' j2me' : is('iphone') ? m + ' iphone' : is('ipod') ? m + ' ipod' : is('ipad') ? m + ' ipad' : is('mac') ? 'mac' : is('darwin') ? 'mac' : is('webtv') ? 'webtv' : is('win') ? 'win' + (is('windows nt 6.0') ? ' vista' : '') : is('freebsd') ? 'freebsd' : (is('x11') || is('linux')) ? 'linux' : '', 'js'];
	c = b.join(' ');
	h.className += ' ' + c;
	return c;
}
css_browser_selector(navigator.userAgent);
// Disable scroll zooming and bind back the click event
//effects iframed google maps  within div with a class of .map-container and with style="pointer-events: none;"
var onMapMouseleaveHandler = function(event) {
		var that = jQuery(this);
		that.on('click', onMapClickHandler);
		that.off('mouseleave', onMapMouseleaveHandler);
		that.find('iframe').css("pointer-events", "none");
	};
var onMapClickHandler = function(event) {
		var that = jQuery(this);
		// Disable the click handler until the user leaves the map area
		that.off('click', onMapClickHandler);
		// Enable scrolling zoom
		that.find('iframe').css("pointer-events", "auto");
		// Handle the mouse leave event
		that.on('mouseleave', onMapMouseleaveHandler);
	};
	// Enable map zooming with mouse scroll when the user clicks the map
	jQuery('.map-container').on('click', onMapClickHandler);
	
	
	
	
	
	